import { render, staticRenderFns } from "./UtmInputFields.vue?vue&type=template&id=45b0cdf1&"
import script from "./UtmInputFields.vue?vue&type=script&lang=js&"
export * from "./UtmInputFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports